import _ from 'lodash';

class selectionMode {
    constructor(arrayTobeUpdate) {
        this.selectedArray = _.cloneDeep(arrayTobeUpdate);
        // Photos the user has tapped in this selection; only these are the user's to change.
        this.touched = new Set();
    }
  
    updateSelectedArray(new_obj, photo_obj, workId) {
        if(!this.selectedArray[workId]){
            // a library folder can hold photos from works we never saw when selection started
            this.selectedArray[workId] = _.cloneDeep(new_obj[workId]) || [];
        }else{
            // Pages keep loading during a selection; take in their items, but never re-add a
            // photo the user has tapped (new_obj can lag a render behind rapid taps).
            const known = new Set(this.selectedArray[workId].map((e) => e.photo_id));
            // Only photo objects (the hide set); download/add-to pass plain id lists here.
            (new_obj[workId] || []).forEach((e) => {
                if (e?.photo_id && !known.has(e.photo_id) && !this.touched.has(e.photo_id)) this.selectedArray[workId].push(_.cloneDeep(e));
            });
        }
        this.touched.add(photo_obj.photo_id);
        if (this.selectedArray[workId].some((e)=> e.photo_id == photo_obj.photo_id)) {
            this.selectedArray[workId] = this.selectedArray[workId].filter((item) => item.photo_id !== photo_obj.photo_id);
        } else {
            this.selectedArray[workId].push(photo_obj);
        }
        return this.selectedArray;
    }
    
}

export function selectionModeArray(arrayTobeUpdate) {
    return new selectionMode(arrayTobeUpdate);
}
  
  